
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m8.5702 12.057c0.72287 1.4778 1.9208 2.6703 3.4019 3.3864 0.1084 0.0514 0.2283 0.0736 0.3478 0.0646 0.1196-0.0091 0.2348-0.0491 0.3342-0.1162l2.1808-1.4542c0.0965-0.0643 0.2075-0.1036 0.3229-0.1142s0.2317 0.0078 0.3383 0.0535l4.0799 1.7485c0.1386 0.0589 0.2543 0.1612 0.3297 0.2916 0.0754 0.1303 0.1064 0.2816 0.0883 0.4311-0.129 1.0091-0.6213 1.9366-1.3849 2.6088-0.7635 0.6722-1.7459 1.0431-2.7632 1.0431-3.142 0-6.1553-1.2481-8.377-3.4699-2.2217-2.2217-3.4699-5.235-3.4699-8.377 6e-5 -1.0173 0.37091-1.9997 1.0431-2.7632 0.67222-0.76355 1.5997-1.2559 2.6088-1.3848 0.14949-0.01809 0.30081 0.01289 0.43117 0.08828 0.13035 0.07539 0.23267 0.1911 0.29155 0.3297l1.7501 4.0835c0.0453 0.10562 0.0637 0.2208 0.0537 0.33527-0.01 0.11448-0.0482 0.2247-0.1111 0.32086l-1.4492 2.2143c-0.06596 0.0996-0.10495 0.2146-0.11317 0.3338-0.00821 0.1192 0.01463 0.2384 0.06629 0.3462v0z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    